"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9097,2428],{

/***/ 2002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgClose = function SvgClose(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "m5.894 5 3.92-3.92A.632.632 0 1 0 8.92.185L5 4.105 1.08.186a.632.632 0 0 0-.895.895L4.105 5 .186 8.92a.632.632 0 1 0 .895.895L5 5.895l3.92 3.92a.632.632 0 1 0 .895-.895z"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgClose);


/***/ }),

/***/ 89097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ plain_banner_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/banner/banner.js + 2 modules
var banner = __webpack_require__(15814);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/banner/layouts/plain-banner/plain-banner-component.scss.js

var StyledPlainBannerComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e430yr0"
})();

;// CONCATENATED MODULE: ./segments/desktop/banner/layouts/plain-banner/plain-banner-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var PlainBannerComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PlainBannerComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PlainBannerComponent);
    function PlainBannerComponent() {
        (0,_class_call_check/* default */.Z)(this, PlainBannerComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PlainBannerComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPlainBannerComponent, {
                    className: "plain-banner-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(banner/* default */.Z, _object_spread_props(_object_spread({}, this.props), {
                        showImages: false
                    }))
                });
            }
        }
    ]);
    return PlainBannerComponent;
}(react.PureComponent);
PlainBannerComponent.defaultProps = banner/* default.defaultProps */.Z.defaultProps;
/* harmony default export */ var plain_banner_component = (PlainBannerComponent);


/***/ }),

/***/ 15814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ banner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 17 modules
var button_button = __webpack_require__(11068);
// EXTERNAL MODULE: ./static/svg/icons/close.svg
var icons_close = __webpack_require__(2002);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/core-components/banner/banner.scss.js




var bannerHeight = "72px";
var bannerTextLinHeight = "24px";
var StyledBanner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1o7tdaf0"
})("min-height:", bannerHeight, ";display:flex;justify-content:center;position:relative;&.top-margin{margin-top:", constants/* default.SECONDARY_HEADER_HEIGHT */.Z.SECONDARY_HEADER_HEIGHT, "px;}.banner-content{display:flex;width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;.image-wrapper{display:flex;flex-grow:0;.banner-image{min-height:", bannerHeight, ";}}&.with-sticky-images{width:auto;align-items:center;.banner-image{height:", bannerTextLinHeight, ";}}.banner-text-and-cta{display:flex;justify-content:center;align-items:center;flex-grow:1;.banner-text-and-link{display:flex;align-items:center;.banner-text{display:inline;font-size:1rem;line-height:", bannerTextLinHeight, ";text-align:center;}.banner-icon-wrapper{display:flex;margin-right:8px;.picture-component{display:flex;}}}.banner-cta-wrapper{display:inline-block;margin-left:24px;min-width:190px;.ladda-button{padding:12px 20px;background:", colors/* default.white */.Z.white, ";", function(param) {
    var buttonTextColor = param.buttonTextColor;
    return buttonTextColor && "color: ".concat(colors/* default */.Z[buttonTextColor], ";");
}, "}}}}.close-icon-wrapper{position:absolute;top:10px;right:10px;cursor:pointer;svg{width:12px;height:12px;path{fill:", colors/* default.white */.Z.white, ";}}}&.hide-banner{display:none;}@media (max-width:", vp_sizes/* MIN_HEADER_DESKTOP_MENU */.dD, "px){&.top-margin{margin-top:0px;}.banner-content{width:initial;.image-wrapper{.banner-picture{display:flex;align-items:center;.banner-image{height:50px;}}}.banner-text-and-cta{margin-left:20px;margin-right:35px;justify-content:center;flex-grow:0;flex-direction:column;.banner-cta-wrapper{margin-left:0;min-width:unset;align-self:start;.secondary-button{font-size:0.8125rem;}}.banner-text-and-link{display:flex;align-items:center;flex-direction:column;gap:10px;.banner-text{font-size:1rem;text-align:left;font-weight:400;}.banner-link{font-size:1rem;}}}}}@media (max-width:600px){.banner-content{.banner-text-and-cta{.banner-text-and-link{display:inline-block;text-align:center;max-width:274px;.banner-text{font-size:0.8125rem;}.banner-link{font-size:0.8125rem;}.banner-cta-wrapper{margin-left:16px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/banner/default-props.js

/* harmony default export */ var default_props = ({
    bannerText: "<monday-bold>Is your team working from home?</monday-bold> Use monday.com to get remote work done",
    bannerCta: "Start Collaborating",
    withCloseIcon: true,
    theme: "dodger-blue",
    buttonConfig: {
        buttonSize: button_component.SM
    },
    extraData: {}
});

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./segments/desktop/core-components/banner/banner.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


















var BANNER_EXPIRE_DAYS = 7;
var SIGNUP_BANNER_PLACEMENT = "top_with_background_banner";
var Banner = function(props) {
    var bannerText = props.bannerText, bannerLinkData = props.bannerLinkData, bannerCta = props.bannerCta, bannerleftImage = props.bannerleftImage, bannerRightImage = props.bannerRightImage, withCloseIcon = props.withCloseIcon, theme = props.theme, buttonConfig = props.buttonConfig, isMobileOrTabletBrowser = props.isMobileOrTabletBrowser, isSecondaryMenuNeeded = props.isSecondaryMenuNeeded, placement = props.placement, hideBannerWithBackground = props.hideBannerWithBackground, stickImagesToText = props.stickImagesToText, extraData = props.extraData, bannerHeight = props.bannerHeight, mobileBannerText = props.mobileBannerText, bannerIcon = props.bannerIcon, bannerIconHeight = props.bannerIconHeight;
    var ref = (0,react.useState)(hideBannerWithBackground && withCloseIcon), hideBanner = ref[0], setHideBanner = ref[1]; // for now only banner that can be closed use the cookie
    var getThemes = function() {
        return _object_spread_props(_object_spread({}, segments_service/* themes */.np), {
            "dodger-blue": {
                color: colors/* default.white */.Z.white,
                background: colors/* default.dodger-blue */.Z["dodger-blue"]
            }
        });
    };
    var getThemeStyle = function() {
        return getThemes()[theme] || {};
    };
    var themeStyle = getThemeStyle();
    var onCloseBanner = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.TOP_BANNER_CLOSED_CLICK);
        (0,cookies_service/* setCookie */.d8)(cookies.HIDE_BANNER_WITH_BACKGROUND_COOKIE_NAME, true, {
            expires: BANNER_EXPIRE_DAYS
        });
        setHideBanner(true);
    };
    var onBannerLinkClicked = function(link) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.BANNER_LINK_CLICKED, {
            kind: link
        });
    };
    var getBannerButtonProps = function() {
        var buttonProps = {
            ctaText: bannerCta,
            placement: placement || SIGNUP_BANNER_PLACEMENT,
            buttonSpinnerColor: themeStyle.background,
            parentSegment: "Banner",
            useCtaText: true,
            extraData: extraData
        };
        if (isMobileOrTabletBrowser) {
            var MOBILE_NOT_ALLOWED_BUTTON_TYPES = [
                button_consts/* REGULAR_BUTTON_TYPE */.ys
            ];
            var buttonType = buttonConfig.buttonType;
            var buttonDisplayType = buttonConfig.buttonDisplayType;
            var extraButtonProps = {};
            if (MOBILE_NOT_ALLOWED_BUTTON_TYPES.includes(buttonType)) {
                extraButtonProps.buttonType = button_consts/* SECONDARY_BUTTON_TYPE */.jE;
            }
            if (buttonConfig.buttonType === button_consts/* YOUTUBE_POPUP_LINK_TYPE */.F9 && MOBILE_NOT_ALLOWED_BUTTON_TYPES.includes(buttonDisplayType)) {
                extraButtonProps.buttonDisplayType = button_consts/* SECONDARY_BUTTON_TYPE */.jE;
            }
            buttonProps = _object_spread_props(_object_spread({}, buttonProps, extraButtonProps), {
                buttonSize: button_component.SM
            });
        }
        return buttonProps;
    };
    var getBannerText = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
            className: "banner-text",
            text: mobileBannerText && isMobileOrTabletBrowser ? mobileBannerText : bannerText,
            style: bannerIcon ? {
                textAlign: "left"
            } : {}
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBanner, {
        className: classnames_default()("banner", {
            "hide-banner": hideBanner,
            "top-margin": isSecondaryMenuNeeded
        }),
        buttonTextColor: theme,
        style: bannerHeight ? _object_spread_props(_object_spread({}, themeStyle), {
            minHeight: bannerHeight
        }) : themeStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("banner-content", {
                    "with-sticky-images": stickImagesToText
                }),
                children: [
                    bannerleftImage && !isMobileOrTabletBrowser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: bannerleftImage,
                            className: "banner-image",
                            pictureClass: "banner-picture"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "banner-text-and-cta",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "banner-text-and-link",
                            style: bannerIcon ? {
                                display: "flex",
                                "flex-direction": "row"
                            } : {},
                            children: [
                                bannerIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "banner-icon-wrapper",
                                    style: {
                                        height: bannerIconHeight
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                        src: bannerIcon
                                    })
                                }),
                                getBannerText(),
                                bannerLinkData && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "banner-link",
                                    href: bannerLinkData.src,
                                    style: {
                                        color: themeStyle.color
                                    },
                                    target: "_blank",
                                    rel: "noreferrer",
                                    onClick: function() {
                                        return onBannerLinkClicked(bannerLinkData.src);
                                    },
                                    children: bannerLinkData.text
                                }),
                                buttonConfig && buttonConfig.buttonType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "banner-cta-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, _object_spread({}, buttonConfig, getBannerButtonProps()))
                                })
                            ]
                        })
                    }),
                    bannerRightImage && !isMobileOrTabletBrowser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: bannerRightImage,
                            className: "banner-image",
                            pictureClass: "banner-picture"
                        })
                    })
                ]
            }),
            withCloseIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "close-icon-wrapper",
                onClick: onCloseBanner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {})
            })
        ]
    });
};
Banner.defaultProps = default_props;
/* harmony default export */ var banner = ((0,generic_config_context/* withGenericConfig */.P)(Banner));


/***/ }),

/***/ 72428:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    BASIC_HEADER_HEIGHT: 72,
    SECONDARY_HEADER_HEIGHT: 56,
    HEADER_CONTENT_HORIZONTAL_PADDING: 32,
    MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT: 52,
    MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT: 44,
    SIGNUP_POPUP_SCREEN_RIGHT_MARGIN: 16,
    SIGNUP_POPUP_SCREEN_WIDTH: 346,
    SIGNUP_POPUP_SCREEN_HEIGHT: 404,
    PRODUCTS_SWITCHER_SCREEN_WIDTH: 300,
    PRODUCTS_SWITCHER_NEW_USERS_SCREEN_HEIGHT: 375,
    PRODUCTS_SWITCHER_EXISTING_USERS_SCREEN_HEIGHT: 270,
    PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN: 32
});


/***/ })

}]);